// extracted by mini-css-extract-plugin
module.exports = {"faqOuter":"_3cymJ","faqHeading":"_3VHGE","faqBox":"_3LGcL","questionWrap":"PKNSU","question":"_3LMZF","answers":"_1a5fa"};